module.exports = __webpack_public_path__ + "static/media/3_DSC_6868.3b9cefa1.webp";